import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import useSeo from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({
    title: "页面不存在_返回话题档案继续追踪｜瓜田雷达",
    description:
      "你访问的页面不存在或已调整。返回话题档案，继续查看网曝吃瓜事件的进展、后续与最新动态时间线。",
    keywords: "页面不存在,话题档案,事件进展,吃瓜追踪",
    path: "/",
  });

  return (
    <>
      <SiteHeader />
      <main className="bg-background-50">
        <div className="flex flex-col items-center px-4 py-20 text-center md:px-8 md:py-28">
          <span className="font-heading text-6xl font-black text-primary-500 md:text-7xl">404</span>
          <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这条路径没有对应的内容
          </h1>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
            页面可能已经调整，或者链接输入有误。你可以回到首页，或者直接进入话题档案，用关键词查找你关心的事件。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line" aria-hidden="true" />
              返回首页
            </Link>
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              <i className="ri-archive-2-line" aria-hidden="true" />
              前往话题档案
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </>
  );
}